import { changeLanguage } from "i18next";
import { useState, createContext, useEffect } from "react";
import "./App.css";
import CanvasContainer from "./CanvasContainer";
import UserInterface from "./UserInterface";
import { camera, fullscreen, menu_panel, ar } from "../src/svgs";
// import TesterComponent from "./TesterComponent";
import './i18n';
import { useTranslation } from "react-i18next";


export const WindowContext = createContext();

function App() {
  const [currentWindow, setCurrentWindow] = useState("2wfb");
  const [currentLanguage, setCurrentLanguage ] = useState("he");
  const [documentDirection, setDocumentDirection] = useState("ltr");

  function updateScreenLanguage() {
    const lang = currentLanguage === "en" ? "he" : "en";
    // const direction = currentLanguage === "en" ? "rtl" : "ltr";

    setCurrentLanguage(lang);
    changeLanguage(lang);
    // setDocumentDirection(direction)
    console.log(documentDirection)
    return false;
  }

  const { i18n } = useTranslation();

  useEffect(() => {
    setDocumentDirection(i18n.dir());
  }, [i18n, i18n.language]);

  // 2w, 2wfb, 3wfb, 3w, 3wAsync, 3wfbAsync
  return (
    <WindowContext.Provider value={{ currentWindow, setCurrentWindow }}>
      <div id="buttons-top">
        <div id="expand" style={{height: "18px", borderRadius: "0px", border: "0px", background: "white"}}>
          <img src={fullscreen} alt="Expand Screen" />
        </div>
        <div id="compress" style={{height: "18px", borderRadius: "0px", border: "0px", background: "white"}}>
          <img src={fullscreen} alt="Compress Screen" />
        </div>
        <div id="btn-print-ar" style={{height: "18px", borderRadius: "0px", border: "0px", background: "white"}}>
          <img src={camera} alt="Augmented Reality" />
        </div>
        <button className="canvas-options__item" onClick={updateScreenLanguage.bind(this)}>
          { currentLanguage === "en" ? "עב" : "en" }
        </button>
        <div id="btn-ar" style={{height: "18px", borderRadius: "0px", border: "0px", background: "white"}}>
          <img src={ar} />
        </div>
      </div>
      <div id="btn-menu-panel">
          <img src={menu_panel} alt="Collapse menu" />
        </div>
      <div id="wrapper">
        <CanvasContainer />
        <UserInterface documentDirection={documentDirection}  />
      </div>
    </WindowContext.Provider>
  );
}

export default App;
